import { render, staticRenderFns } from "./IconSearchCircleSolid.vue?vue&type=template&id=08016045"
import script from "./IconSearchCircleSolid.vue?vue&type=script&lang=js"
export * from "./IconSearchCircleSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports